import { ClientCultureContextProvider } from '@ori/culture-provider';
import { TranslationsNamespaceProvider, TranslationsProvider } from '@ori/i18n';
import { ShoppingContextProvider } from '@ori/shopping-context';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { StrictMode, Suspense, type FC } from 'react';

import { MiniBagWrapper } from '../components';
import { APP_NAME, eventNames, translationsNamespace } from '../constants';
import type { ClientAppConfig } from '../types';
import { getTranslationsProps, normalizeConfigData } from '../utils';
import { ApiConfigurationProvider } from './ApiConfigurationProvider';
import { ApiProvider } from './ApiProvider';

export const MiniShoppingBagController: FC<ClientAppConfig> = (configuration) => {
  const usedConfiguration = normalizeConfigData(configuration);
  const translationProps = getTranslationsProps(usedConfiguration);
  const { currentLanguage, staticApiUrl, tenant, useOpenedMinibagOnDesktop } = usedConfiguration;
  const apiProviderProps = { currentLanguage, staticApiUrl, tenant };
  const cultureProviderProps = { host: staticApiUrl, tenant };

  return (
    <StrictMode>
      <ShoppingContextProvider eventNames={eventNames}>
        <Suspense fallback={null}>
          <TestIdProvider
            project={APP_NAME}
            team={Team.Checkout}
          >
            <ApiProvider {...apiProviderProps}>
              <ApiConfigurationProvider tenant={tenant}>
                <ClientCultureContextProvider {...cultureProviderProps}>
                  <TranslationsProvider {...translationProps}>
                    <TranslationsNamespaceProvider namespace={translationsNamespace}>
                      <MiniBagWrapper useOpenedMinibagOnDesktop={useOpenedMinibagOnDesktop} />
                    </TranslationsNamespaceProvider>
                  </TranslationsProvider>
                </ClientCultureContextProvider>
              </ApiConfigurationProvider>
            </ApiProvider>
          </TestIdProvider>
        </Suspense>
      </ShoppingContextProvider>
    </StrictMode>
  );
};
